module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACpJREFUeNpi/A8EDAQAIyNjIwORgImBymDUwFEDRw0cNXDUwKFiIECAAQDh+ASoAGHc9gAAAABJRU5ErkJggg=="


/*****************
 ** WEBPACK FOOTER
 ** ./~/url-loader!./bower_components/prettyphoto/images/prettyPhoto/facebook/contentPatternRight.png
 ** module id = 95
 ** module chunks = 0
 **/